import React from "react";
import { Link } from "react-router-dom";
import { GoArrowUpRight } from "react-icons/go";

const ServiceCard = ({ service }) => {
  return (
    <Link
      to={service.url}
      className="hover:ring-primary flex flex-col justify-between rounded-2xl p-6 text-left ring-1 ring-[#0000004F] transition duration-300 hover:scale-105 hover:ring-2 hover:transition-transform"
    >
      <div>
        <img
          src={service.icon}
          alt={service.title}
          className="mb-4 size-14 xl:mb-9"
        />
        <h3 className="text-primary mb-3 text-2xl font-medium xl:mb-5">
          {service.title}
        </h3>
        <p className="text-gray mb-6 text-base xl:mb-13">
          {service.description}
        </p>
      </div>
      <button className="text-primary inline-flex items-center gap-1 xl:gap-2 rounded-2xl text-xl xl:text-2xl font-medium transition-transform duration-300 hover:translate-x-2 hover:scale-105">
        View Service
        <GoArrowUpRight className="xl:text-3xl" />
      </button>
    </Link>
  );
};

export default ServiceCard;
